import React, { useState, useEffect,useRef,useCallback, useMemo  } from 'react'
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from './LanguageContext';
import TiltCard from './hooks/TiltCard'
const ProductCard = ({ resu, toggleFavorite, addToRecentView, t, handleQuickView }) => {

const customTranslations = {
  'campânula': {
    'es': 'Campana',
    'en': 'High bay',
    'fr': 'Campanule',
    'it': 'Campanula',
    'zh-CN': '风铃草'
  },
  'luminária': {
    'es': 'Luminaria',
    'en': 'Luminaire',
    'fr': 'Luminaire',
    'it': 'Apparecchio di illuminazione',
    'zh-CN': '灯具'
  }
};
  const [translatedName, setTranslatedName] = useState(resu.nome);
  const { selectedLanguage } = useLanguage();

    useEffect(() => {
    let newName = resu.nome;

    if (selectedLanguage && selectedLanguage !== 'pt') {
      for (const originalWord in customTranslations) {
        const translatedWord = customTranslations[originalWord][selectedLanguage];

        if (translatedWord) {
          const regex = new RegExp(originalWord, 'gi');
          newName = newName.replace(regex, translatedWord);
        }
      }
    } else {
      // Retorna ao nome original se o idioma for português ou não estiver selecionado
      newName = resu.nome;
    }
    setTranslatedName(newName);
  }, [resu.nome, selectedLanguage]);

    useEffect(() => {
      if (window.$ && window.$.fn.tilt) {
        window.$("[data-tilt]").tilt({
          speed: 250,
          max: 10,
          perspective: 500,
        });
      }
    }, []);
  const [hovered, setHovered] = useState(false);
  return (
      <div className="shop__thumb" data-tilt data-tilt-speed="250" data-tilt-max="10" data-tilt-perspective="500" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
        {/* Exibe "Novidade" se o produto for novo */}
        {handleQuickView && (
          <div className='wd-buttons'>
          <button className="quick-view-button" onClick={(e) => { e.preventDefault(); handleQuickView(resu.idP);}} aria-label="Visualizar">
            <i className="fas fa-search" />
          </button>
          </div>
        )}

        {resu.novo == 1 && <h6 className="novidades-button">{t("listProds.novo")}</h6>}
        {/* Botão de favorito, visível apenas para usuários logados */}
        <Link to={`/prodetail/${encodeURIComponent(resu.nome.replace(/\s+/g, "-").toLowerCase())}/${resu.idP}`} target="_blank" onClick={() => addToRecentView(resu.idP)} title={resu.nome}>
          <div className="shop-thumb__img">
           <img src={hovered && resu.hoverImg ? resu.hoverImg : resu.imgP} className="img-responsive"alt={resu.nome} />
          </div>
          <h3 className="shop-thumb__title translate pnome">
            <b>{translatedName}</b>
          </h3>
          <h5 className="shop-thumb-brand b-name">{resu.marca}</h5>

          {/* Exibição das Referências */}
          <h5 className="shop-thumb-brand ref-pvp mb-1">
            <div className="ref-block">
              <span className="references">Ref:</span>&nbsp;
              {resu.prodEspe}
            </div>
            <div className='pvp-text'>
              <span className="pvp-value">{typeof resu.pvp === "number" ? <span className="references">P.V.P.</span> : ""}</span>
           </div>
          </h5>

          {/* Exibição do IP e do preço PVP */}
          <div className="ip-pvp-container">
          {resu?.ip != null ? (
          <span className="shop-thumb-brand second-block">
                   <span className="no-bold">IP {resu.ip}</span>
                  </span> ): <span  className='no-ip'>
              </span>}
          <span className="pvp-value">
          {resu.pvp != null && !isNaN(resu.pvp) ? `${parseFloat(resu.pvp).toFixed(2)}€` : ""}
          </span>
          </div>

          <div className="potencia-container">
          {resu?.w != null ? (
              <span className="shop-thumb-brand">
                  <span className="no-bold"><s className="text-capitalize">{t('pdetail.potencia')}:</s> {resu.w}W</span>
                </span> ): <span className=''></span>}
            {resu?.volt != null ? (
              <span className="shop-thumb-brand second-block">
                    <span className="no-bold volt"> {resu.volt}V</span>
                  </span> ): <span  className='no-ip'>
            </span>}
          </div>
        </Link>
      </div>
  );
};

export default ProductCard;